import { render, staticRenderFns } from "./CompanyNavToCatalogAction.vue?vue&type=template&id=a9065f78&scoped=true&"
import script from "./CompanyNavToCatalogAction.vue?vue&type=script&lang=js&"
export * from "./CompanyNavToCatalogAction.vue?vue&type=script&lang=js&"
import style0 from "./CompanyNavToCatalogAction.vue?vue&type=style&index=0&id=a9065f78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9065f78",
  null
  
)

export default component.exports